import { Eye, X, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useImpersonation } from '@/contexts/ImpersonationContext';

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, endImpersonation } = useImpersonation();

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  const handleEndImpersonation = async () => {
    try {
      await endImpersonation();
      // Optionally refresh the page to reset all state
      window.location.reload();
    } catch (error) {
      console.error('Failed to end impersonation:', error);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-amber-950 shadow-lg">
      <div className="container mx-auto px-4 py-2">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <AlertTriangle className="h-5 w-5" />
              <Eye className="h-5 w-5" />
            </div>
            <div className="flex items-center gap-2">
              <span className="font-semibold">Impersonation Mode</span>
              <span className="hidden sm:inline">—</span>
              <span className="hidden sm:inline">
                Impersonating{' '}
                <strong>
                  {impersonatedUser.first_name} {impersonatedUser.last_name}
                </strong>
              </span>
              <Badge 
                variant="outline" 
                className="bg-amber-600/20 border-amber-700 text-amber-950 capitalize"
              >
                {impersonatedUser.role === 'employee' ? 'Cashier' : impersonatedUser.role}
              </Badge>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-sm hidden md:inline opacity-80">
              All actions are logged
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={handleEndImpersonation}
              className="bg-amber-600 hover:bg-amber-700 border-amber-700 text-white gap-1"
            >
              <X className="h-4 w-4" />
              <span className="hidden sm:inline">End Impersonation</span>
              <span className="sm:hidden">End</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}





